import { accountState } from '@/app/model/store/domain/types'

export default {
  setAccountList (state: accountState, payload: any) {
    state.accountData = payload
  },

  setAllFieldData (state: accountState, payload: any) {
    state.allFieldData = payload
  },

  setChoiceAccountType (state: accountState, payload: number) {
    state.choiceAccountType = payload
  },

  setOrderNum (state: accountState, payload: number) {
    state.orderNum = payload
  },

  setSort (state: accountState, payload: string) {
    state.sort = payload
  },

  setSearchText (state: accountState, payload: string) {
    state.searchText = payload
  }
}
